export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-eject-935a86080c73d828b2e9607ffc18426e.svg";